"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chainProp = void 0;
const monet_1 = require("monet");
const _1 = require(".");
function chainProp(key, x) {
    const fn = (_key, _x) => (0, _1.safeProp)(_key, _x)
        .chain(val => monet_1.Maybe.isInstance(val) ? (0, monet_1.Just)(val) : (0, monet_1.None)())
        .chain((I) => I);
    return arguments.length === 2
        ? fn(key, x)
        : (y) => fn(key, y);
}
exports.chainProp = chainProp;
//# sourceMappingURL=chain.js.map